import { PayoutRequisitesBalanceRedistributionRequest } from 'types';

import { createCrudApi } from './crud.api';

export const payoutRequisitesBalanceRedistributionRequestsApi =
  createCrudApi<PayoutRequisitesBalanceRedistributionRequest>(
    '/payout-requisites-balance-redistribution-requests',
  );
